import { trigger, transition, query, style, animate, state, group, animateChild } from '@angular/animations';

export const slideInStatsAnimation = trigger('statsAnimation', [
  state('minimized', style({
    height: '60px'
  })),
  state('expanded', style({
    height: '*'
  })),
  transition('void => minimized', [
    style({ height: '0px' }),
    animate('300ms ease-in', style({ height: '60px' }))
  ]),
  transition('minimized => expanded', [
    group([
      animate('500ms ease-in-out'),
      query('@statsDetailedAnimation', animateChild())
    ])
  ]),
  transition('expanded => minimized', [
    group([
      query('@statsDetailedAnimation', animateChild()),
      animate('500ms ease-in-out', style({ height: '60px' }))
    ])
  ])
]);

export const slideInDetailedStatsAnimation = trigger('statsDetailedAnimation', [
  state('minimized', style({
    top: '4px'
  })),
  state('expanded', style({
    top: '0px'
  })),
  transition('minimized => expanded', [
    animate('500ms cubic-bezier(.63,-8,.27,4.5)')
  ]),
  transition('expanded => minimized', [
    animate('500ms cubic-bezier(.93,-3.0,.57,6)')
  ])
]);
